import {Global} from './variables'
import store from '../app/store'
import {DealerData} from '../types/dealer'

export const PARTNER_DEFAULT = {
    informationBnr: undefined,
    informationName: undefined,
}

export const DEFAULT_ACTIVITY_TYPE = 2
export const DEFAULT_CONTRACT_TYPE = 12714013

const KEYS = {
    informationBnr: 'dealer_id',
    informationName: 'ragione-sociale',
}
export const getPartner = (partner: {[x: string]: string}) => {
    const informationBnr = partner[KEYS.informationBnr]

    return {
        informationBnr: informationBnr
            .trim()
            .substring(0, informationBnr.length - 2),
        informationName: partner[KEYS.informationName].trim(),
    }
}

export const getCustomPartner = (partner: {[x: string]: string}) => ({
    informationBnr: partner[KEYS.informationBnr].trim(),
    informationName: partner[KEYS.informationName].trim(),
})

export const getVersionKey = () =>
    store.getState().general.isDealerWeb
        ? Global.DW_SW_KEY
        : Global.NATIONAL_KEY

export const getSourceKey = () => {
    if (store.getState().general.isDealerWeb) {
        return Global.DEALER_WEB_SOURCE
    }

    return Global.NATIONAL_KEY
}

export const generateRandomString = (length: number) =>
    Array.from(Array(length), () =>
        Math.floor(Math.random() * 36).toString(36)
    ).join('')

export const getAllQueryParams = () => {
    const queryParams: Record<string, string> = {}
    const searchParams = new URLSearchParams(window.location.search)

    for (const param of searchParams.entries()) {
        queryParams[param[0]] = param[1]
    }

    return queryParams
}

export const stripTags = (str: string) =>
    (str ?? '')
        .replace(/<br\s*\/?>/gi, ' ')
        .replace(/<[^>]+>/g, '')
        .replace(/\s+/g, ' ')
        .trim()

export const capitalizeWords = (str: string) =>
    str
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')

export const getDealerInfoOption = (option: any) =>
    `${option.company} - ${option.address}${
        option.streetNumber ? ' ' + option.streetNumber : ''
    }, ${option.city}`

export const getDealerAddress = (option: any) =>
    `${option.address}${
        option.streetNumber ? ' ' + option.streetNumber : ''
    }, ${option.city}`

const RAW_SUFFIXES = ['snc', 'srl', 'srls', 'sas', 'spa']

export const removeCompanySuffix = (name: string): string => {
    const normalized = name.toLowerCase().replace(/\./g, '')
    // eslint-disable-next-line security/detect-non-literal-regexp
    const pattern = new RegExp(`\\b(${RAW_SUFFIXES.join('|')})(\\s+.*)?`, 'i')

    const match = pattern.exec(normalized)

    if (!match) {
        return name
    }

    const index = normalized.indexOf(match[0])

    return name.substring(0, index).trim()
}

export const getFetchedDealerFromCode = (
    myDealerBranches: [],
    myDealerCode: string
): DealerData | null =>
    Array.isArray(myDealerBranches)
        ? myDealerBranches.find(
              (dealerData: DealerData) =>
                  dealerData.companyCode === myDealerCode
          ) || null
        : null
